import { memo as Memo, useMemo } from 'react'

//* Components
import { Text, ButtonFollow, CustomLink, Avatar } from 'components/common'

//* Style
import TopCreatorsStyle from './style'

const TopCreators = Memo(({ title, members }) => {
	const storeMember = useMemo(() => {
		return members?.map((i, k) => (
			<div className='single-member flexBox' key={k}>
				<div className='left flexBox'>
					<CustomLink url={`/${i.username}`}>
						<Avatar src={i.avatar} />
					</CustomLink>
					<div className='info flexBoxColumn'>
						<CustomLink url={`/${i.username}`}>
							<Text tag={'h5'} className='h5 PopSemi' text={i.name} />
						</CustomLink>
						<Text tag={'p'} className='h7 PopReg grey' text={`${i.debatesCount} debates created`} />
					</div>
				</div>
				<ButtonFollow className={`blueBg`} followingId={i.id} />
			</div>
		))
	}, [members])

	return (
		<TopCreatorsStyle className='flexBoxColumn'>
			<Text tag={'p'} className='title h9 PopSemi' text={title} />
			{storeMember}
		</TopCreatorsStyle>
	)
})

export default TopCreators